import { User } from '@greenkub-fronts/shared/interface';
import jwt_decode from 'jwt-decode';

interface DecodedToken {
  roles: string[];
}

export const getRoleFromToken = () => {
  const localAuth = localStorage.getItem('auth');

  if (localAuth) {
    const parsedAuth = JSON.parse(localAuth);

    if (parsedAuth && parsedAuth.token) {
      const decoded: DecodedToken = jwt_decode(parsedAuth.token);

      if (decoded && decoded.roles) {
        if (
          decoded.roles.includes('ROLE_GK') ||
          decoded.roles.includes('ROLE_SUPER_ADMIN')
        ) {
          return 'GK';
        }
        if (decoded.roles.includes('ROLE_CUSTOMER')) {
          return 'CUSTOMER';
        }
      }
    }
  }
  return '';
};

export const isServiceClient = (user: User | undefined) => {
  if (!user) return false;

  const emails = [
    'helene.iovino@greenkub.fr',
    'laura.bosc@greenkub.fr',
    'nicolas.renvoye@greenkub.fr',
  ];

  return (
    user.team?.name.includes('Service Clients') || emails.includes(user.email)
  );
};

export const isSalesMember = (user: User | undefined) => {
  if (!user) return false;

  const emails = ['nicolas.renvoye@greenkub.fr'];

  return user.team?.name.includes('Sales') || emails.includes(user.email);
};

export const isFinanceMember = (user: User | undefined) => {
  if (!user) return false;
  return (
    user.team?.name.includes('DIRECTION') ||
    user.team?.name.includes('Finance') ||
    user.team?.name.includes('Contrôle') ||
    user.team?.name.includes('MARKETING & WEB')
  );
};
